module.exports = __webpack_public_path__ + "assets/img/certificate_icon.svg";